import React, { Component } from 'react';
import axios from 'axios'
import { firebaseAuth, pythonApiIp, toCurrency } from '../../../../config/constants'
import { Form, Segment, Button, Divider, } from 'semantic-ui-react'
import { SingleDatePicker } from 'react-dates';
import * as UiConsts from '../../../../config/UiConstants';

import createBrowserHistory from 'history/createBrowserHistory';
const history = createBrowserHistory({ forceRefresh: true });

class CostMarkProjectCost extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false
        }
    }

    handleTextInputChange = (e) => {
        // console.log("hx1 >>>>: handleTextInputChange clicked");
        // console.log("hx33 e.target.type:" + e.target.type);
        console.log("hx32 e.target.name:" + e.target.name);
        console.log("hx34 e.target.value:" + e.target.value);
        let newState = {};
        newState[e.target.name] = e.target.value;

        let name = e.target.name;
        let value = e.target.value;

        this.setState(newState);

    }


    sendMarkCost = (action) => {
        console.log("++++++++:sendMarkCost +++++++");
        console.log("this.props.costId:" + this.props.costId)
        console.log("action:" + action)

        if (this.props.costId == '') {
            alert("No costId Person")
        } else if (!action) {
            alert("No action Provided")
        } else {
            console.log("sending data..");

            this.setState({ loading: true });

            axios.post(pythonApiIp + 'markProjectExpense', {
                apiKey: "PrintB@da7",
                costId: this.props.costId,
                action: action
            })
                .then((response) => {
                    this.setState({
                        loading: false
                    })
                    console.log(response.data);

                    if (response.data.result) {
                        console.log("true.. adding project");

                        alert(response.data.message);
                       history.push("/dashboard/viewLargeProject/" + this.props.projectId);
                    } else {
                        console.log("FAILED");
                        this.setState({ loading: false });
                        alert(response.data.message);
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.setState({
                        loading: false
                    })
                });
        }
    }

    ignoreCost = () => {
        console.log("++++ ignore cost ++++");
        this.sendMarkCost("ignore")
    }

    logCost = () => {
        console.log("++++ ignore cost ++++");
        this.sendMarkCost("log")
    }

    render() {

        const markCostUi =
            <div>
                <Button color='blue' onClick={this.ignoreCost}>IGNORE</Button>
                <Button color='orange' onClick={this.logCost}>LOG</Button>
            </div>


        return (this.state.loading ? <UiConsts.LoadingComponent /> : <div>
            {markCostUi}

        </div>);
    }
}

export default CostMarkProjectCost;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/LargeProjects/CostMarkProjectCost.js